// Section 12 Options Definitions - Oktatók értékelése

export const OTHV_OPTIONS = {
    hu: [
        { value: 'kivalo', label: 'Kiváló (>4.5)' },
        { value: 'megfelelo', label: 'Megfelelő (4.0–4.49)' },
        { value: 'hatarertekközeli', label: 'Határérték közeli (3.6–3.99)' },
        { value: 'fejlesztendo', label: 'Fejlesztendő (<3.6)' }
    ],
    en: [
        { value: 'kivalo', label: 'Excellent (>4.5)' },
        { value: 'megfelelo', label: 'Adequate (4.0–4.49)' },
        { value: 'hatarertekközeli', label: 'Close to threshold (3.6–3.99)' },
        { value: 'fejlesztendo', label: 'Requires development (< 3.6)' }
    ]
};

export const HALLGATOI_VISSZAJELZESEK_OPTIONS = {
    hu: [
        { value: 'pozitiv', label: 'Pozitív értékelések' },
        { value: 'ertheto', label: 'Érthető tananyag' },
        { value: 'tul_magas', label: 'Túl magas követelés' },
        { value: 'hozzaferesi_problema', label: 'Tananyag hozzáférési probléma' },
        { value: 'szervezesi_problema', label: 'Szervezési probléma' }
    ],
    en: [
        { value: 'pozitiv', label: 'Positive classroom management' },
        { value: 'ertheto', label: 'Clear and comprehensible course materials' },
        { value: 'tul_magas', label: 'Excessive workload' },
        { value: 'hozzaferesi_problema', label: 'Issues with access to course materials' },
        { value: 'szervezesi_problema', label: 'Organizational issues' }
    ]
};

export const KIEMELKEDO_TANTARGYAK_OPTIONS = {
    hu: [
        { value: 'tobb_kivalo', label: 'Több kiváló tárgy' },
        { value: 'egy_ket_pelda', label: 'Egy-két példa' },
        { value: 'nincs_kiemelkedo', label: 'Idén nincs kiemelkedő példa' }
    ],
    en: [
        { value: 'tobb_kivalo', label: 'Several outstanding courses' },
        { value: 'egy_ket_pelda', label: 'One or two examples' },
        { value: 'nincs_kiemelkedo', label: 'No outstanding examples identified this year' }
    ]
};
